module.exports = __webpack_public_path__ + "static/media/planInactive.b41f1cb3.png";